import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/lib/motion";

export function Overline({ children, className = "" }) {
  return <span className={`fine-uppercase text-[0.68rem] text-champagne ${className}`}>{children}</span>;
}

export function SectionHeading({ overline, title, italic, sub, center, dark }) {
  return (
    <div className={`${center ? "text-center mx-auto max-w-2xl" : "max-w-2xl"}`}>
      {overline && (
        <Reveal>
          <div className={`flex items-center gap-4 mb-6 ${center ? "justify-center" : ""}`}>
            <span className="champagne-rule" />
            <Overline>{overline}</Overline>
            {center && <span className="champagne-rule" />}
          </div>
        </Reveal>
      )}
      <Reveal delay={0.05}>
        <h2 className={`font-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight ${dark ? "text-warm-ivory" : "text-espresso"}`}>
          {title} {italic && <span className={`italic font-normal ${dark ? "text-champagne" : "text-walnut"}`}>{italic}</span>}
        </h2>
      </Reveal>
      {sub && (
        <Reveal delay={0.1}>
          <p className={`mt-6 text-lg leading-[1.75] font-light ${dark ? "text-warm-ivory/70" : "text-espresso/70"}`}>{sub}</p>
        </Reveal>
      )}
    </div>
  );
}

export function GoldLink({ to, href, children, testid, dark }) {
  const cls = `group inline-flex items-center gap-3 fine-uppercase text-[0.72rem] ${dark ? "text-warm-ivory" : "text-espresso"}`;
  const inner = (
    <>
      <span className="link-underline pb-1">{children}</span>
      <ArrowUpRight size={14} strokeWidth={1.6} className="text-champagne group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
    </>
  );
  return to ? (
    <Link to={to} data-testid={testid} className={cls}>{inner}</Link>
  ) : (
    <a href={href} data-testid={testid} className={cls}>{inner}</a>
  );
}

export function PageHero({ overline, title, italic, sub, image }) {
  return (
    <section className="relative pt-36 md:pt-44 pb-16 md:pb-24 overflow-hidden bg-warm-ivory">
      <div className="mx-auto max-w-[1500px] px-6 md:px-12">
        {overline && (
          <div className="flex items-center gap-4 mb-6">
            <span className="champagne-rule" />
            <Overline>{overline}</Overline>
          </div>
        )}
        <h1 className="font-display text-5xl md:text-7xl lg:text-[5.5rem] leading-[1.02] tracking-tight max-w-4xl text-espresso">
          {title} {italic && <span className="italic font-normal text-walnut">{italic}</span>}
        </h1>
        {sub && <p className="mt-6 text-lg md:text-xl text-espresso/70 max-w-2xl leading-[1.75] font-light">{sub}</p>}
      </div>
      {image && (
        <div className="mx-auto max-w-[1500px] px-6 md:px-12 mt-14">
          <div className="overflow-hidden">
            <img src={image} alt={title} className="w-full h-[42vh] md:h-[64vh] object-cover" loading="eager" />
          </div>
        </div>
      )}
    </section>
  );
}
